import FileInput from './js/FileInput';

export default FileInput;
